import { createContext, useContext } from "react";

type ContextType = {
  showNoColorValue?: boolean;
  activeColors?: string[];
};

export const ColorPaletteContext = createContext<ContextType | undefined>(undefined);

const useColorPaletteContext = ():ContextType => {
  const context = useContext(ColorPaletteContext);
  if ( !context ) throw new Error('useColorPaletteContext must be used within a ColorPaletteProvider');
  return context;
}

export default useColorPaletteContext;
